import { displayTextLabelValidator, nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultMemberSubscriptionDisplayText = {
    recurringSubscriptionTagLabel: 'Recurring',
    nonRecurringSubscriptionTagLabel: 'One-off payment',
    onHoldTagLabel: 'On hold',
    expiringSoonTagLabel: 'Expiring soon',
    paymentFailedTagLabel: 'Payment failed',
    cancelledTagLabel: 'Cancelled',
    changeSubscriptionButtonLabel: 'Change subscription',
    cancelSubscriptionButtonLabel: 'Cancel subscription',
    renewSubscriptionButtonLabel: 'Renew now',
    futureNonRecurringSubscriptionLabel: 'Valid from ${futureSubscriptionStartDate|d|Do MMMM YYYY} until ${futureSubscriptionEndDate|d|Do MMMM YYYY}',
    nextSubscriptionPaymentDueLabel: [
        'Next subscription payment due ',
        {
            text: '${nextSubscriptionPaymentDueDate|d|Do MMMM YYYY}',
            className: 'v-member-subscription-base__description-date'
        }
    ],
    canRenewOnLabel: [
        'Can renew on ',
        {
            text: '${canRenewOnDate|d|Do MMMM YYYY}',
            className: 'v-member-subscription-base__description-date'
        }
    ],
    lastSubscriptionPaymentFailedLabel: [
        'Last subscription payment failed to charge on ',
        {
            text: '${lastSubscriptionPaymentFailedDate|d|Do MMMM YYYY}',
            className: 'v-member-subscription-base__description-date'
        }
    ],
    activeAgainLabel: [
        'Active again on ',
        {
            text: '${activeAgainDate|d|Do MMMM YYYY}',
            className: 'v-member-subscription-base__description-date'
        }
    ],
    startDateLabel: ['Start Date ', '${date|d|D MMM YYYY}'],
    endDateLabel: ['End Date ', '${date|d|D MMM YYYY}'],
    cancellationModalHeading: 'Cancel your subscription',
    cancellationModalMessage: [
        'Your subscription will be cancelled on ',
        {
            text: '${endDate|d|D MMM YYYY}',
            className: 'v-member-subscription-cancellation-modal__description--end-date'
        },
        ". You can keep using your subscription's benefits until that date.",
        '\n',
        'To continue, confirm your cancellation. This action cannot be undone.'
    ],
    cancellationFromFrozenSubscriptionModalMessage: 'Your subscription will be cancelled immediately. \n To continue, confirm your cancellation. This action cannot be undone.',
    cancellationModalConfirmButtonLabel: 'Confirm',
    cancellationModalCloseButtonLabel: 'Go back',
    failedToCancelSubscriptionMessage: 'Sorry, something went wrong.',
    successfullyCancelledSubscriptionMessage: "We've cancelled your subscription. You can keep using its benefits until: ${endDate|d|D MMM YYYY}.",
    successfullyCancelledFromFrozenSubscriptionMessage: "We've cancelled your subscription."
};
export const memberSubscriptionDisplayTextValidator = Validator.object({
    recurringSubscriptionTagLabel: nonEmptyStringValidator,
    nonRecurringSubscriptionTagLabel: nonEmptyStringValidator,
    onHoldTagLabel: nonEmptyStringValidator,
    expiringSoonTagLabel: nonEmptyStringValidator,
    paymentFailedTagLabel: nonEmptyStringValidator,
    cancelledTagLabel: nonEmptyStringValidator,
    changeSubscriptionButtonLabel: nonEmptyStringValidator,
    cancelSubscriptionButtonLabel: nonEmptyStringValidator,
    renewSubscriptionButtonLabel: nonEmptyStringValidator,
    futureNonRecurringSubscriptionLabel: nonEmptyStringValidator,
    nextSubscriptionPaymentDueLabel: displayTextLabelValidator,
    canRenewOnLabel: displayTextLabelValidator,
    lastSubscriptionPaymentFailedLabel: displayTextLabelValidator,
    activeAgainLabel: displayTextLabelValidator,
    startDateLabel: displayTextLabelValidator,
    endDateLabel: displayTextLabelValidator,
    cancellationModalHeading: nonEmptyStringValidator,
    cancellationModalMessage: displayTextLabelValidator,
    cancellationFromFrozenSubscriptionModalMessage: displayTextLabelValidator,
    cancellationModalConfirmButtonLabel: nonEmptyStringValidator,
    cancellationModalCloseButtonLabel: nonEmptyStringValidator,
    failedToCancelSubscriptionMessage: nonEmptyStringValidator,
    successfullyCancelledSubscriptionMessage: nonEmptyStringValidator,
    successfullyCancelledFromFrozenSubscriptionMessage: nonEmptyStringValidator
});
